import React from 'react';
import ChartVenn from '../../vennDiagram/ChartVenn';
import { HistogramChartEmptyState } from '../chart/HistogramChartEmptyState';
import { ModalPopupContentInset, ModalVennChartInset, ModalVennTabRoot } from '../HistogramPanel.styled';
import VennCategoryRadios from '../../components/VennCategoryRadios';
import { useCohortAnalyzer } from '../../context/CohortAnalyzerContext';

export function HistogramPopupModalVennTab({
  vennModalChartAreaRef,
  vennModalShowsChart,
  chartVennModalProps,
  containerRef,
  canvasRef,
  vennModalSlot,
  vennModalShowsEmptyState,
}) {
  const {
    selectedCohorts,
    nodeIndex,
    setNodeIndex,
    setRowData,
  } = useCohortAnalyzer();

  return (
    <ModalVennTabRoot>
      <ModalPopupContentInset>
        <VennCategoryRadios
          selectedCohorts={selectedCohorts}
          nodeIndex={nodeIndex}
          setNodeIndex={setNodeIndex}
          setRowData={setRowData}
          alignWithModalHeader
        />
      </ModalPopupContentInset>
      <ModalVennChartInset ref={vennModalChartAreaRef}>
        {vennModalShowsChart ? (
          <ChartVenn
            {...chartVennModalProps}
            containerRef={containerRef}
            canvasRef={canvasRef}
            slotWidth={vennModalSlot.slotWidth}
            slotHeight={vennModalSlot.slotHeight}
            expandedView
          />
        ) : vennModalShowsEmptyState ? (
          <div
            style={{
              width: '100%',
              flex: 1,
              minHeight: Math.max(280, vennModalSlot.slotHeight - 40),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxSizing: 'border-box',
            }}
          >
            <HistogramChartEmptyState />
          </div>
        ) : null}
      </ModalVennChartInset>
    </ModalVennTabRoot>
  );
}
